// otpauth:// → QR（authenticator App 掃描）；另外列出 secret 供手動輸入。
import { useMemo } from 'react';
import qrcode from 'qrcode-generator';
import { useTranslation } from 'react-i18next';

export function TotpQr({ uri, secret }: { uri: string; secret: string }) {
  const { t } = useTranslation();
  const svg = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(uri);
    qr.make();
    return qr.createSvgTag({ cellSize: 4, margin: 2, scalable: true });
  }, [uri]);
  return (
    <div className="totp-qr">
      {/* qrcode-generator 產生的 SVG 只含矩形，沒有使用者輸入的 HTML */}
      <div className="totp-qr-img" role="img" aria-label={t('mfa.qr_alt')} dangerouslySetInnerHTML={{ __html: svg }} />
      <div className="small muted">{t('mfa.manual_entry')}</div>
      <code className="mono totp-secret">{secret.replace(/(.{4})/g, '$1 ').trim()}</code>
    </div>
  );
}

export function RecoveryCodes({ codes }: { codes: string[] }) {
  const { t } = useTranslation();
  return (
    <div className="recovery">
      <p className="notice">{t('mfa.recovery_notice')}</p>
      <ol className="recovery-list mono">
        {codes.map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ol>
      <button type="button" className="btn btn-sm" onClick={() => void navigator.clipboard?.writeText(codes.join('\n'))}>
        {t('mfa.copy_codes')}
      </button>
    </div>
  );
}
